import React from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { CommonStyles, Color, CommonProperties } from '../../styles';
import PNRInfo from './PNRInfo';
import TabBar from '../SegmentedControl/TabBar';
import PassengerInfo from './PassengerInfo';
import Slide from './Slide';
import BaseText from '../BaseText';
import Images from '../../constants/Images';
import { useNavigation } from '@react-navigation/native';
import { Modals, Screens } from '../../constants/ScreenNames';
import { scale } from '../../utils/scale.utils';
import useAvailableHeight from '../../utils/useAvailableHeight';

const TRACKTRAIN = 'TRACKTRAIN';
const SEATS = 'SEATS';
const TRAINS = 'TRAINS';

const railTabItems = [
  { icon: 'station', second: 'Track Train', value: TRACKTRAIN },
  { icon: 'classBasic', second: 'Seats', value: SEATS },
  { icon: 'rail', second: 'Trains', value: TRAINS },
];

const getTrainNumber = (leg) => leg?.RailSegments?.[0].TrainNumber;

const RailPage = ({ leg, passengers }) => {
  const navigation = useNavigation();
  const availableHeight = useAvailableHeight(scale(150));
  const trainNumber = getTrainNumber(leg);
  const onChange = (value) => {
    switch (value) {
      case TRACKTRAIN:
        navigation.navigate(Modals.TrackTrainWebModal);
        break;
      case SEATS:
        navigation.navigate(Modals.RailSeatModal);
        break;
      case TRAINS:
        navigation.navigate(Screens.RailChange);
        break;
    }
  };

  return (
    <ScrollView style={[CommonStyles.py2, CommonStyles.flex1]}>
      <View style={{ height: availableHeight, backgroundColor: 'white' }}>
        <Slide
          image={
            leg.VendorName.toLowerCase().includes('acela')
              ? Images.rail['24x24']['AC']
              : Images.rail['24x24']['AM']
          }
          name={leg.VendorName}
          detail={trainNumber ? 'Train Number ' + trainNumber : null}
          startLabel="Departs"
          startTime={leg.DepartTime ? leg.DepartTime.split(' ').join('') : null}
          startDetail={leg.DepartureLocationCode}
          endLabel={'Arrives'}
          endTime={leg.ArrivalTime ? leg.ArrivalTime.split(' ').join('') : null}
          endDetail={leg.ArrivalLocationCode}
        >
          <BaseText>20m Ride</BaseText>
        </Slide>
        {/* <TabBar primary items={railTabItems} onChange={onChange} style={styles.tabBar} /> */}
        <View style={{ backgroundColor: 'white' }}>
          <PNRInfo style={CommonStyles.mb3} label="Rail Record Locator" value="QZASDF" />
          {passengers?.length > 0
            ? passengers.map((passenger, index) => (
                <PassengerInfo
                  key={index}
                  label="Passenger"
                  value={passenger.FirstName + ' ' + passenger.LastName}
                />
              ))
            : null}
        </View>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  tabBar: {
    borderTopWidth: 0.1,
    borderTopColor: Color.gray,
    ...CommonProperties.py5,
  },
});

export default RailPage;
